import { render } from "./InsuranceTable.vue?vue&type=template&id=5b50bf56&scoped=true"
import script from "./InsuranceTable.vue?vue&type=script&lang=js"
export * from "./InsuranceTable.vue?vue&type=script&lang=js"

import "./InsuranceTable.vue?vue&type=style&index=0&id=5b50bf56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b50bf56"]])

export default __exports__